const rectFromPoints = (p1, p2) => {
  return {
    width: Math.abs(p1.x - p2.x),
    height: Math.abs(p1.y - p2.y),
    left: Math.min(p1.x, p2.x),
    top: Math.min(p1.y, p2.y),
    right: Math.max(p1.x, p2.x),
    bottom: Math.max(p1.y, p2.y)
  };
};

const rectOverlapsRect = (rect1, rect2) => {
  return rect1.bottom > rect2.top && rect1.top < rect2.bottom && rect1.right > rect2.left && rect1.left < rect2.right;
};

const rectOverlapsRectX = (rect1, rect2) => {
  return rect1.right > rect2.left && rect1.left < rect2.right;
};

const rectOverlapsRectY = (rect1, rect2) => {
  return rect1.bottom > rect2.top && rect1.top < rect2.bottom;
};

const pointOverlapsRect = (point, rect) => {
  return point.y > rect.top && point.y < rect.bottom && point.x > rect.left && point.x < rect.right;
};

const rectUnion = (rect1, rect2) => {
  const left = Math.min(rect1.left, rect2.left);
  const right = Math.max(rect1.right, rect2.right);
  const top = Math.min(rect1.top, rect2.top);
  const bottom = Math.max(rect1.bottom, rect2.bottom);

  return {
    left,
    right,
    top,
    bottom,
    width: right - left,
    height: bottom - top
  };
};

const rectIntersectionArea = (rect1, rect2) => {
  const noIntersect =
    rect2.left > rect1.right || rect2.right < rect1.left || rect2.top > rect1.bottom || rect2.bottom < rect1.top;
  if (noIntersect) {
    return false;
  }

  const intersectingRect = {
    left: Math.max(rect1.left, rect2.left),
    top: Math.max(rect1.top, rect2.top),
    right: Math.min(rect1.right, rect2.right),
    bottom: Math.min(rect1.bottom, rect2.bottom)
  };
  const area = (intersectingRect.right - intersectingRect.left) * (intersectingRect.bottom - intersectingRect.top);

  return area;
};

export default {
  rectFromPoints,
  rectOverlapsRect,
  rectOverlapsRectX,
  rectOverlapsRectY,
  pointOverlapsRect,
  rectUnion,
  rectIntersectionArea
};
